import { makeStyles } from 'tss-react/mui'
import { Instance as TinyColor } from 'tinycolor2';

const useStyles = makeStyles<{color: TinyColor, showOnlySwatch: boolean}>()((theme, {color, showOnlySwatch}) => ({
    container: {
        position: 'relative',
        display: 'flex',
    },
    swatch: {
        width: 'auto',
        borderRadius: '4px',
        cursor: 'pointer',
        minWidth: 0,
        '&.compact': {
            width: '100%',
            alignItems: 'center'
        },
    },
    swatchBackground: {
        height: showOnlySwatch ? '20px' : '4px',
        width: '20px',
        borderRadius: showOnlySwatch ? '2px' : 0,
        position: 'relative',
        overflow: 'hidden',
        
        backgroundColor: showOnlySwatch ? undefined : color.toRgbString(),

        '&::before': {
            content: showOnlySwatch ? '""' : undefined,
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            backgroundImage: `linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%)`,
            backgroundSize: '8px 8px',
            backgroundPosition: '0 0, 0 4px, 4px -4px, -4px 0px',
            width: '100%',
            height: '100%',
        },
        '&::after': {
            content: showOnlySwatch ? '""' : undefined,
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            backgroundColor: color.toRgbString(),
            width: '100%',
            height: '100%',
        }
    },
    checkeredBackground: {
        
    },
    border: {
        border: `1px solid ${theme.palette.grey[400]}`
    },
    compact: {},
    value: {
        marginLeft: '5px',
        color: theme.palette.text.primary
    },
    colorInput: {
        width: 0,
        height: 0,
        overflow: 'hidden',
        position: 'absolute',
        left: 0,
        bottom: 0
    }
}))

export default useStyles